import React from 'react';
import Tag from '../../Tags/Tag/Tag';

export const renderTags = (tags) =>
  tags.map((tag) => (
    <Tag key={tag?.title} link={tag?.link} title={tag?.title} color={tag?.color} />
  ));
